/**
 * NOTE (kyle): this file is just a way of stubbing nanoid without
 * flow-typed.
 */

/*
import {customAlphabet} from 'nanoid';

// NOTE (kyle): we can safely generate 1000 of these ids per hour
// without any chance of collision.
//
// See https://zelark.github.io/nano-id-cc/ for more info.
//
// If this isn't enough entropy we should consider using this to
// gennerate a prefix per session and then incrementing a suffix
// to generate ids.
const idGen: () => string = customAlphabet('1234567890', 16);
const intIdGen = (): number => parseInt(idGen());
export default intIdGen;
*/

/**
 * generates a random 32-bit integer.
 */
export default function generateId(): number {
  const randomArray = new Uint32Array(1);
  return window.crypto.getRandomValues(randomArray)[0];
}

/**
 * Mints a UUID string. Uses `crypto.randomUUID()` when available (Node 17+ /
 * modern browsers); falls back to a time + random hex string in environments
 * that lack it (older WebViews, some test runners). The fallback is not RFC
 * 4122 compliant — collision odds are still well below what a single client
 * session will produce, but don't use it as a server-side primary key.
 */
export function mintId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}
